module.exports = __webpack_public_path__ + "img/p2@2x.6e3dd31a.png";